import { render, staticRenderFns } from "./EditHotelFormDialog.vue?vue&type=template&id=4b229248"
import script from "./EditHotelFormDialog.vue?vue&type=script&lang=js"
export * from "./EditHotelFormDialog.vue?vue&type=script&lang=js"
import style0 from "./EditHotelFormDialog.vue?vue&type=style&index=0&id=4b229248&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports